const initGtag = ()=>{
    const gtagKey = process.env.GOOGLE_ANALYTICS_KEY;
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${gtagKey}`;
    document.head.appendChild(script);
    script.onload = ()=>{
        window.dataLayer = window.dataLayer || [];
        function gtag() {
            dataLayer.push(arguments);
        }
        gtag('js', new Date());
        gtag('config', gtagKey);
    };
};
initGtag();

//# sourceMappingURL=index.cb0bf205.js.map
